import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {RiderService} from './rider.service';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [RiderService]
})
export class RidersRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/riders/riders-routing.module.ts